import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function CanalesYResponsabilidad() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XI. CANALES PARA SOLICITAR INFORMACIÓN SOBRE LAS PLATAFORMAS Y PARA PRESENTACIÓN DE PQRS.</h4>
          <br></br>
          <p>
            El Usuario dispone de varios canales a su disposición para solicitar información sobre las plataformas, ejercer sus derechos, presentar peticiones, quejas o reclamos de manera directa:
          </p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p>
                Visite en nuestro sitio web <a href="http://www.parking.net.co" target="_blank" rel="noopener noreferrer">www.parking.net.co</a>    
              </p>
            </li>
            <li>
              <p>
                Comuníquese a nuestra línea telefónica de atención al cliente +57 300 910 9787.
              </p>
            </li>
            <li>
              <p>
                Contáctenos por medio del correo electrónico <a href="mailto:servicioalcliente@parking.net.co">servicioalcliente@parking.net.co</a>.
              </p>
            </li>
            <li>
              <p>
                Otros canales que se habiliten para este fin publicados en la página web.
              </p>
            </li>
          </ul>
          <br></br>  
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XII. RESPONSABILIDAD DEL USUARIO FRENTE AL USO DE LAS PLATAFORMAS</h4>
          <br></br>
          <p>
            Es responsabilidad del Usuario/ Cliente Corporativo. de las Plataformas mantener sus datos actualizados para garantizar una experiencia segura y personalizada. El Usuario/ Cliente Corporativo debe proporcionar información precisa y veraz, revisando y actualizando regularmente detalles como dirección, número de teléfono y correo electrónico. Cualquier error o cambio significativo debe ser corregido inmediatamente. La protección de las credenciales de acceso es crucial, y cualquier sospecha de acceso no autorizado debe ser reportada de inmediato. La falta de actualización puede afectar la calidad del servicio, resultar en brechas de seguridad y conllevar la suspensión o terminación de la cuenta. Nuestro equipo de soporte está disponible para asistir a los usuarios en este proceso y responder cualquier pregunta relacionada.
          </p>
        </Col>
      </Row>
    </Container>
  );
}